import { CORE_URL } from '../../../helpers/env'
export const API_URL = CORE_URL

export const GET_TASKS = 'GET_TASKS'
export const GET_TASKS_SUCCESS = 'GET_TASKS_SUCCESS'
export const GET_TASKS_FAILED = 'GET_TASKS_FAILED'

export const GET_TASK_SUMMARY = 'GET_TASK_SUMMARY'
export const GET_TASK_SUMMARY_SUCCESS = 'GET_TASK_SUMMARY_SUCCESS'
export const GET_TASK_SUMMARY_FAILED = 'GET_TASK_SUMMARY_FAILED'

export const TRANSITION_TASK = 'TRANSITION_TASK'
export const TRANSITION_TASK_SUCCESS = 'TRANSITION_TASK_SUCCESS'
export const TRANSITION_TASK_FAILED = 'TRANSITION_TASK_FAILED'

export const COMMENT_TASK = 'COMMENT_TASK'
export const COMMENT_TASK_SUCCESS = 'COMMENT_TASK_SUCCESS'
export const COMMENT_TASK_FAILED = 'COMMENT_TASK_FAILED'

export const BULK_CLOSE_TASKS = 'BULK_CLOSE_TASKS'
export const BULK_CLOSE_TASKS_SUCCESS = 'BULK_CLOSE_TASKS_SUCCESS'
export const BULK_CLOSE_TASKS_FAILED = 'BULK_CLOSE_TASKS_FAILED'
